import React, { useContext, useState } from "react";
import { useNavigateOptional } from "../../../utils/hooks";
import { Button } from "../../button/Button";
import { AppContext } from "../../layout/AppContext";
import { Menu, MenuItem } from "../Menu";
import { PopOver } from "../PopOver";
import styles from "./Breadcrumbs.scss";

export const Breadcrumbs = ({ children }) => {
    const navigate = useNavigateOptional();
    const [popVisible, setPopVisible] = useState(false);
    const { pageInfo } = useContext(AppContext);

    const handlePopClick = () => {
        if (children?.length > 2) {
            setPopVisible(!popVisible);
        } else {
            navigate(children?.[0]?.props?.link);
        }
    };

    return (
        <div className={styles.base}>
            <div className={styles.pop}>
                <PopOver
                    padding="regular"
                    visible={popVisible}
                    onClose={() => setPopVisible(false)}
                    content={<CrumbItems crumbs={children} onClose={() => setPopVisible(false)} />}
                >
                    <Button
                        size={pageInfo.breakpoint === "mobile" ? "tiny" : "small"}
                        square
                        active={popVisible}
                        className={styles.button}
                        onClick={handlePopClick}
                        color={popVisible ? "accent" : null}
                        iconColor="primary"
                        icon="arrow-left"
                    />
                </PopOver>
            </div>
            <div className={styles.container}>{children}</div>
        </div>
    );
};

const CrumbItems = ({ crumbs, onClose }) => {
    return (
        <Menu>
            {crumbs?.length
                ? React.Children.map(crumbs, (crumb, index) =>
                      index < crumbs.length - 1 ? (
                          <MenuItem
                              key={index}
                              icon={crumb.props?.icon || "chevron-right"}
                              label={crumb.props.label}
                              link={crumb.props.link}
                              onClick={onClose}
                          />
                      ) : null
                  )
                : null}
        </Menu>
    );
};

Breadcrumbs.defaultProps = {
    homeIcon: "menu-squares"
};
